import { css, Theme } from "@emotion/react";
import { theme } from "styles/theme";

export const BOTTOM_NAVIGATE_HEIGHT = "64px";

export const BottomNavigateStyle = {
  self: css`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 20;
  `,

  radioGroup: css`
    width: 100%;
    display: flex;
    background: linear-gradient(
      to bottom,
      ${theme.colors.orange[200]},
      ${theme.colors.orange[100]}
    );
  `,

  radioItemWrapper: ({ colors }: Theme) => css`
    flex: 1;
    border-radius: 0 !important;
    border: none;
    padding: 2px;
    line-height: 1.2;
    &::before {
      top: 1px !important;
      height: calc(100% - 3px) !important;
      background-color: ${theme.colors.orange[200]} !important;
    }
    height: ${BOTTOM_NAVIGATE_HEIGHT};
    background-color: transparent;
    transition: none !important;
    color: ${colors.white} !important;
    &.ant-radio-button-wrapper-checked {
      background-color: ${theme.colors.gradient[50]} !important;
    }

    &:where(
        .css-dev-only-do-not-override-fpg3f5
      ).ant-radio-button-wrapper:first-of-type {
      border-inline-start: 0 !important;
    }
  `,

  radioItem: css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
  `,

  itemLabel: css`
    font-size: 9px;
    text-transform: uppercase;
  `,
};
